/** Username: 3–20 chars, letters, digits, underscore. */
export const USERNAME_PATTERN = /^[a-zA-Z0-9_]{3,20}$/;
